var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"handle-wrap"},[_c('div',{staticClass:"handle-btn"},[_c('p',{on:{"click":_vm.showRecord}},[_c('img',{attrs:{"src":"//res.aidalan.com/hd/sg/img/record.png"}})]),_vm._v(" "),_c('p',{on:{"click":_vm.showAddr}},[_c('img',{attrs:{"src":"//res.aidalan.com/hd/sg/img/receive.png"}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/.13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-5b310ba2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/.13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/Handle.vue
// module id = null
// module chunks = 